import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class SubjectsTable<T> extends Vue {
  @Prop({ type: Array })
  protected data!: T[];

  @Prop({ type: Array, default: () => [] })
  protected selectedItems!: string[];

  protected popupMessage = "";
  protected action = "";

  protected showPopup = false;

  protected selectedDataItemsIds: string[] = [];

  protected isSelected(subjectId: string) {
    return this.selectedDataItemsIds.includes(subjectId);
  }

  protected selectItem(subjectId: string) {
    const alreadyExists = this.isSelected(subjectId);

    if (alreadyExists) {
      this.selectedDataItemsIds = this.selectedDataItemsIds.filter(
        id => id !== subjectId
      );
    } else {
      this.selectedDataItemsIds = [...this.selectedDataItemsIds, subjectId];
    }

    this.$emit("on-select-item", this.selectedDataItemsIds);
  }
}
